import localize from '../locale';
import { DataProjectId } from '../models/data-project';

const DATA_PROJECTS_WITH_METRIC_LABEL_OVERRIDES = [DataProjectId.GBD, DataProjectId.RACE_ETHNICITY];

export const getMetricLabelOverridesByDataProject = (
    dataProjectId: number | undefined | null
): Record<string, string> => {
    const suffix = DATA_PROJECTS_WITH_METRIC_LABEL_OVERRIDES.includes(dataProjectId as number)
        ? `_data_project_${dataProjectId}`
        : '_default';

    return {
        metric_2: localize(`metric_2${suffix}`),
        long_metric_2: localize(`long_metric_2${suffix}`),
    };
};
